// eslint-disable-next-line no-restricted-imports
import { ActionDataModel, ActionModel } from 'app/gamma/src/types/models';
// eslint-disable-next-line no-restricted-imports
import {
  ActionDataResponse,
  ActionResponse,
} from 'app/gamma/src/types/responses';

import genericNormalizer, { normalizeDate } from './generic';

import { normalizeButlerRule } from './butler';
import { normalizeBoard } from './board';
import { normalizeCard } from './card';
import { normalizeOrganization } from './organization';
import { normalizeChecklist, normalizeChecklistItem } from './checklist';
import { normalizeList } from './list';
import { normalizeMember } from './member';

import { boardUrlFromShortLink } from '@trello/urls';

// eslint-disable-next-line @trello/no-module-logic
export const normalizeActionData = genericNormalizer<
  ActionDataResponse,
  ActionDataModel
>(({ from, has }) => ({
  board: has('board', (board) =>
    normalizeBoard({
      ...board,
      url:
        board.shortLink && board.name
          ? boardUrlFromShortLink(board.shortLink, board.name)
          : undefined,
    }),
  ),
  card: has('card', normalizeCard),
  cardSource: from('cardSource'),
  checkItem: has('checkItem', normalizeChecklistItem),
  checklist: has('checklist', normalizeChecklist),
  list: has('list', normalizeList),
  listAfter: has('listAfter', normalizeList),
  listBefore: has('listBefore', normalizeList),
  name: from('name'),
  plugin: from('plugin'),
  organization: has('organization', normalizeOrganization),
  text: from('text'),
  actionType: from('actionType'),
  rule: has('rule', normalizeButlerRule),
  idExport: from('idExport'),
  signature: from('signature'),
}));

// eslint-disable-next-line @trello/no-module-logic
export const normalizeAction = genericNormalizer<ActionResponse, ActionModel>(
  ({ has, from }) => ({
    board: has('board', normalizeBoard),
    card: has('card', normalizeCard),
    data: has('data', normalizeActionData),
    date: has('date', normalizeDate),
    display: from('display'),
    id: from('id'),
    idMemberCreator: from('idMemberCreator'),
    list: has('list', normalizeList),
    member: has('member', normalizeMember),
    memberCreator: has('memberCreator', normalizeMember),
    memberInviter: has('memberInviter', normalizeMember),
    type: from('type'),
  }),
);
